export enum RawDataReportsFields {
  ProductType = 'productType',
}
